import React from 'react';
import { Tooltip } from '@material-ui/core';
import Zoom from '@material-ui/core/Zoom';

const ToolTipCustom = ({text,placement="top",children}) => 
{
    return <Tooltip title={text} arrow placement={placement} TransitionComponent={Zoom} TransitionProps={{ timeout: 150 }}>
        {children}
    </Tooltip>
}

export default ToolTipCustom
